export const state = () => ({
    features: null,
})

export const getters = {
    hasDropshippingFeature(state, getters, rootState, rootGetters) {
        return (
            rootGetters['global/account']?.isEligibleForDropshipping ||
            rootGetters['global/isSupplier']
        )
    },

    hasDropshippingApiFeature(state, getters, rootState, rootGetters) {
        return state?.features?.includes('ds-api')
    },
    hasOneBrandFeature(state) {
        return !!state?.features?.includes('no-ds-marketplace')
    },
    forcesV2(state) {
        return !!state?.features?.includes('marketplace-v2')
    },
}

export const mutations = {
    updateFeatures(state, payload) {
        state.features = payload
    },
}
